import moment from 'moment'

import { IAppointmentActivity } from '../../types'
import { IAPIAppointmentActivity } from '../../types/api'

export const apiAppointmentActivityTransformer = (
  apiActivity: IAPIAppointmentActivity,
  appointmentId: number,
): IAppointmentActivity => ({
  activityId: apiActivity.activity_id,
  id: apiActivity.id,
  appointmentId,
  personId: apiActivity.person_id,
  startsAt: moment(apiActivity.starts_at),
  endsAt: moment(apiActivity.ends_at),
  isLocked: apiActivity.is_locked,
  appointmentActivityUuid: apiActivity.uuid,
})
